import { useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button, Page, Stack, Text } from "@shopify/polaris";

import { trial } from "../../assets/index.js";

const OnboardingTrialComponent = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleContinue = useCallback(() => {
    navigate("/billing")
  }, [searchParams])

  return (
    <Page fullWidth>
      <div style={{ display: "flex", justifyContent: "space-between", paddingTop: 80 }}>
        <div style={{ width: "50%" }}>
          <Stack spacing="extraLoose" vertical>
            <Text variant="heading3xl" as="p">
              You will not be charged unless you keep the app longer than the 5-day free trial.
            </Text>
            <Text variant="bodyMd" as="p">
              If you dont want the app, you can uninstall it or switch to our free plan.
            </Text>
            <Button onClick={handleContinue} primary>
              Continue
            </Button>
          </Stack>
        </div>
        <div style={{ width: "50%", marginLeft: 50, display: "flex", justifyContent: "center" }}>
          <div style={{ maxWidth: 380, minWidth: 150 }}>
            <img
              alt="trial"
              style={{
                width: "100%",
                objectFit: "cover",
                objectPosition: "center",
              }}

              src={trial}
            />
          </div>
        </div>
      </div>
    </Page>
  );
};

export default OnboardingTrialComponent;